<template>
  <div>
    <v-app-bar app elevation="0" class="admin-app-bar">
      <button
        type="button"
        class="admin-brand"
        aria-label="Reload admin dashboard"
        @click="clickAction"
      >
        <AdminBrandLogo />
      </button>

      <v-spacer class="app-bar-spacer"></v-spacer>
      <div
        v-if="location && recentLocation.length > 1"
        class="app-bar-location"
      >
        <LocationChange
          :location="location"
          @submit="handleLocationChange"
        />
      </div>
      <Menu />
    </v-app-bar>
  </div>
</template>

<script>
// import employeeService from "@/modules/Employee/service";
import Menu from "@/components/AppBarMenu.vue";
import LocationChange from "@/modules/Home/components/LocationChange.vue";
import AdminBrandLogo from "@/components/AdminBrandLogo.vue";
import { mapGetters } from "vuex";

export default {
  name: "app-bar",
  data() {
    return {
      drawer: false,
      recentLocation: [],
    };
  },
  components: {
    Menu,
    LocationChange,
    AdminBrandLogo,
  },
  computed: {
    ...mapGetters("global", { location: "getLocation" }),
  },
  created() {
    try {
      this.recentLocation =
        JSON.parse(
          localStorage.getItem(
            `${process.env.VUE_APP_STORAGE_PREFIX}recentLocation`
          )
        ) || [];
    } catch (error) {
      this.recentLocation = [];
    }
  },

  methods: {
    clickAction() {
      this.$router.go(0);
    },
    handleLocationChange() {
      this.$router.go(0);
    },
  },
};
</script>

<style scoped>
.admin-app-bar {
  border-bottom: 1px solid rgba(148, 163, 184, 0.16) !important;
  background: rgba(7, 17, 31, 0.94) !important;
  backdrop-filter: blur(16px);
}

.theme--light .admin-app-bar {
  border-bottom-color: rgba(15, 23, 42, 0.09) !important;
  background: rgba(255, 255, 255, 0.94) !important;
}

.admin-brand {
  display: inline-flex;
  padding: 5px 8px;
  align-items: center;
  border: 0;
  border-radius: 12px;
  background: transparent;
  cursor: pointer;
}

.admin-brand:active {
  background: rgba(96, 165, 250, 0.08);
}

.app-bar-location {
  width: 230px;
  min-width: 0;
  flex: 0 1 230px;
  margin-right: 10px;
}

@media (max-width: 600px) {
  .admin-app-bar {
    padding: 0 8px !important;
  }

  .admin-brand {
    display: none;
  }

  .app-bar-spacer {
    display: none;
  }

  .app-bar-location {
    width: auto;
    max-width: calc(100% - 52px);
    flex: 1 1 auto;
    margin-right: 6px;
  }
}

@media (max-width: 370px) {
  .app-bar-location {
    max-width: calc(100% - 48px);
  }
}
</style>
